import { useEffect, useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";

import { SectionAccordionArrowDownIcon } from "../assets/icons/go-hire-page-icons";

const CreateJobAccordion = ({
  title,
  children,
  error = false,
}: {
  title: string;
  children: React.ReactNode;
  error?: boolean;
}) => {
  const [expanded, setExpanded] = useState<boolean>(false);

  const handleChange = (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded);
  };

  useEffect(() => {
    if (error) setExpanded(error);
  }, [error]);

  return (
    <Accordion sx={styles.accordion(error)} expanded={expanded} onChange={handleChange}>
      <AccordionSummary expandIcon={<SectionAccordionArrowDownIcon />}>
        <Typography component="span" sx={styles.accordionTitle}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={styles.accordionDetails}>{children}</AccordionDetails>
    </Accordion>
  );
};

export default CreateJobAccordion;

const styles = {
  accordion: (error: boolean) => ({
    "&:before": {
      display: "none !important",
    },
    borderRadius: "12px !important",
    border: "1px solid var(--Gray-200, #EAECF0)",
    background: "var(--Gray---25, #F7F8F8)",
    padding: "16px",
    boxShadow: "none !important",

    "& .MuiAccordionSummary-root": {
      padding: "0",
      minHeight: "unset",
    },
    "& .MuiAccordionSummary-content": {
      margin: "0",
    },
    ...(error && {
      border: "2px solid var(--Red-500, #F04438)",
    }),
  }),
  accordionTitle: {
    fontFamily: "Montserrat",
    color: "var(--Gray-900, #101828)",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "28px",
  },
  accordionDetails: {
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
};
